module.exports = __webpack_public_path__ + "static/media/ParkingSpaceCounter.77c8b565.jpg";